// extracted by mini-css-extract-plugin
export default {"appContent":"AppContent_appContent__SVJYz"};